<template>
  <div class="view" :style="cropStyle">
    <img :style="imageStyle" :src="imageSource" />
    <measure-skeleton
      class="absolute"
      :projection="side"
      :crop="cropGuides"
      :width="getPictureWidth"
      :height="getPictureHeight"
      :zoom="cropGuides.growthFactor"
      :heightZoom="1"
    />

    <!-- <div class="points absolute top-0 left-0">
      <measure-point v-for="point in 43" :key="point" :point-number="point" :side="side" />
    </div>-->
  </div>
</template>

<script>
import MeasureSkeleton from "./measure-skeleton.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MeasureSkeleton
  },
  computed: {
    ...mapGetters([
      "getBackGuides",
      "getSideGuides",
      "getSideWidth",
      "getBackWidth",
      "getCropBack",
      "getCropSide",
      "getPictureHeight",
      "getPictureWidth"
    ]),

    cropGuides() {
      if (this.side === "back") {
        return this.getCropBack.crop;
      }
      return this.getCropSide.crop;
    },
    imageStyle() {
      var payload = {
        height: this.getPictureHeight * this.cropGuides.growthFactor + "px",
        marginTop:
          "-" +
          this.cropGuides.y *
            this.getPictureHeight *
            this.cropGuides.growthFactor +
          "px",
        marginLeft:
          "-" +
          this.cropGuides.x *
            this.getPictureWidth *
            this.cropGuides.growthFactor +
          "px",
        transform: this.flipped ? "scaleX(-1)" : "scaleX(1)"
      };
      return payload;
    },
    cropStyle() {
      return {
        position: "relative",
        height: this.getPictureHeight + "px",
        width:
          this.cropGuides.width *
            this.getPictureWidth *
            this.cropGuides.growthFactor +
          "px",
        // border: "2px solid red",
        overflow: "hidden",
        marginRight: "5px"
      };
    }
  },
  props: {
    imageSource: String,
    isActive: Boolean,
    side: String,
    flipped: Boolean
  },
  data() {
    return {
      points: 43,
      growthFactor: ""
    };
  }
};
</script>

<style>
.view {
  position: relative;
}
img {
  max-width: none !important;
}
</style>
